import React, { useState } from 'react';
import { PinturaEditor } from '@pqina/react-pintura';
import '@pqina/pintura/pintura.css';

import {
  createDefaultImageReader,
  createDefaultImageWriter,
  createDefaultShapePreprocessor,
  setPlugins,
  plugin_crop,
  plugin_finetune,
  plugin_finetune_defaults,
  plugin_filter,
  plugin_filter_defaults,
  plugin_annotate,
  markup_editor_defaults,
  createNode,
} from '@pqina/pintura';

import {
  LocaleCore,
  LocaleCrop,
  LocaleFinetune,
  LocaleFilter,
  LocaleAnnotate,
  LocaleMarkupEditor,
} from '@pqina/pintura/locale/en_GB';

setPlugins(plugin_crop, plugin_finetune, plugin_filter, plugin_annotate);

// Custom API Filter
const customApiFilter = async (imageData) => {
  console.log('Calling API filter...');

  const canvas = document.createElement('canvas');
  canvas.width = imageData.width;
  canvas.height = imageData.height;
  const ctx = canvas.getContext('2d');
  ctx.putImageData(imageData, 0, 0);

  const blob = await new Promise((resolve) =>
    canvas.toBlob(resolve, 'image/jpeg', 0.95)
  );

  const formData = new FormData();
  formData.append('image', blob);

  try {
    const response = await fetch('https://your-api.com/filter', {
      method: 'POST',
      body: formData,
    });

    const processedBlob = await response.blob();
    const img = await createImageBitmap(processedBlob);

    const resultCanvas = document.createElement('canvas');
    resultCanvas.width = img.width;
    resultCanvas.height = img.height;
    const resultCtx = resultCanvas.getContext('2d');
    resultCtx.drawImage(img, 0, 0);

    return resultCtx.getImageData(
      0,
      0,
      resultCanvas.width,
      resultCanvas.height
    );
  } catch (error) {
    console.error('API Filter Error:', error);
    // Для тесту - просто інвертуємо кольори
    const data = imageData.data;
    for (let i = 0; i < data.length; i += 4) {
      data[i] = 255 - data[i]; // red
      data[i + 1] = 255 - data[i + 1]; // green
      data[i + 2] = 255 - data[i + 2]; // blue
    }
    return imageData;
  }
};

const editorDefaults = {
  utils: ['crop', 'finetune', 'filter', 'annotate'],
  imageReader: createDefaultImageReader(),
  imageWriter: createDefaultImageWriter(),
  shapePreprocessor: createDefaultShapePreprocessor(),
  ...plugin_finetune_defaults,
  ...plugin_filter_defaults,
  ...markup_editor_defaults,

  locale: {
    ...LocaleCore,
    ...LocaleCrop,
    ...LocaleFinetune,
    ...LocaleFilter,
    ...LocaleAnnotate,
    ...LocaleMarkupEditor,
  },
};

export default function Example() {
  const [result, setResult] = useState('');
  const [loading, setLoading] = useState(false);
  const [editorInstance, setEditorInstance] = useState(null);

  // ⭐ Функція для додавання custom кнопки в toolbar
  const willRenderToolbar = (toolbar, env, redraw) => {
    const { isModal, isFullscreen, isMaximized } = env;

    // Створити custom кнопку
    const customButton = createNode('Button', 'button', {
      label: '✨ AI Magic',
      onclick: async () => {
        console.log('AI Magic clicked!');
        setLoading(true);

        try {
          if (editorInstance) {
            // Отримати поточне зображення
            const currentImageData = editorInstance.imageData;

            // Викликати API filter
            const processed = await customApiFilter(currentImageData);

            // Застосувати результат
            editorInstance.imageData = processed;

            console.log('Processing complete!');
          }
        } catch (error) {
          console.error('Error:', error);
          alert('Processing failed: ' + error.message);
        } finally {
          setLoading(false);
        }
      },
    });

    // Додати кнопку в toolbar
    // toolbar - це масив елементів
    toolbar.push(['div', 'custom-button-container', [customButton]]);

    return toolbar;
  };

  return (
    <div>
      <h2>Example with Custom Button</h2>

      {loading && (
        <div
          style={{
            padding: '10px',
            background: '#4A90E2',
            color: 'white',
            marginBottom: '10px',
            borderRadius: '5px',
            textAlign: 'center',
          }}
        >
          🔄 Processing with AI... Please wait
        </div>
      )}

      <div style={{ height: '70vh' }}>
        <PinturaEditor
          {...editorDefaults}
          src={'./image.jpeg'}
          ref={setEditorInstance}
          onLoad={(res) => {
            console.log('load image', res);
          }}
          onProcess={({ dest }) => {
            setResult(URL.createObjectURL(dest));
            setLoading(false);
          }}
          willRenderToolbar={willRenderToolbar}
        />
      </div>

      {!!result.length && (
        <div style={{ marginTop: '20px' }}>
          <h3>Result:</h3>
          <img
            src={result}
            alt="Processed"
            style={{ maxWidth: '100%', border: '2px solid #ddd' }}
          />
        </div>
      )}
    </div>
  );
}
